import * as React from "react";
export class SortedHeading extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-my-pulse-bets__sorted-heading-message" },
            React.createElement("span", { className: "rj-my-pulse-bets__sorted-heading-message-text" }, this.props.text)));
    }
}
//# sourceMappingURL=SortedHeading.js.map